module.exports = __webpack_public_path__ + "img/1.ad87fa84.png";